import { SvgActionMenuOptions } from './types';

export const svgActionMenuOptionDefaults: SvgActionMenuOptions = {
	menuButtonRadius: 1.75,
	menuButtonPadding: 1,
	itemButtonRadius: 2.25,
	itemButtonPadding: 1,
	menuTooltipPadding: 0.5
};
